// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * Created by Inzamam Janjua on 18/05/2023.
 */
.gc-agency-name {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: #1f2937;
}

p.gc-agency-handle {
  font-style: italic;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  color: rgba(75, 85, 99, 0.5);
  width: 160px;
}

.disabled {
  pointer-events: none;
  cursor: default;
  opacity: 0.6;
}

.gc-agency-img {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff;
  color: #2d388b;
  text-align: center;
  font-size: 25px;
  font-weight: 600;
  flex: 0 0 46px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.leftBoder-4 {
  border-left: 4px solid #0A6ED9 !important;
}

.episodeLeftBorder-4 {
  border-left: 4px solid #6ACE6A !important;
}

.gc-user-img {
  justify-self: start;
}

.submission-details {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.submission-poup-content {
  padding: 20px 24px;
}
.submission-poup-content .submission-card {
  background: #F6F8FF;
  border-radius: 16px;
  padding: 24px;
}
.submission-poup-content .submission-card .submission-details label {
  font-weight: 600;
  font-size: 16px;
  line-height: 30px;
  color: #4B5563;
  opacity: 0.5;
}
.submission-poup-content .submission-card .submission-details span {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: #1F2937;
}
.submission-poup-content .submission-card .gc-submission-user {
  display: flex;
  align-items: center;
  gap: 13px;
}
.submission-poup-content .submission-card .gc-submission-user .SU-avatar {
  width: 68px;
  height: 68px;
  background: #E7ECF0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  color: #000000;
}
.submission-poup-content .submission-card .gc-submission-user .SU-info p {
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;
  color: #1F2937;
}
.submission-poup-content .submission-card .gc-submission-user .SU-info span {
  font-style: italic;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: #4B5563;
  opacity: 0.5;
}
.submission-poup-content button.accept-btn {
  padding: 10px 12px;
  border: none;
  width: 119px;
  height: 40px;
  background: rgba(16, 185, 129, 0.1);
  border-radius: 6px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #10B981;
  cursor: pointer;
}
.submission-poup-content button.recheck-btn {
  width: 119px;
  height: 40px;
  background: rgba(251, 191, 36, 0.1);
  border-radius: 6px;
  border: none;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #FBBF24;
  cursor: pointer;
}

.btn-text {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #8F95B2;
  background: none;
  border: none;
  cursor: pointer;
}

.button-container {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
  border-top: 1px solid #ECF0F5;
  gap: 24px;
}

.close-button {
  color: black;
  border: 1px solid black;
  background-color: white;
  gap: 24px;
}

.color {
  color: blue;
}

.custom-button {
  color: gray;
  border: none;
  text-decoration: none;
  background-color: transparent;
}

.custom-button:hover {
  text-decoration: underline;
}

.text-black {
  color: #1F2937;
}

.clearBtn {
  background: none;
  border: none;
  padding-right: 10px;
  cursor: pointer;
}

.dropzone {
  position: relative;
  height: 345px;
  width: 100%;
  border: 2px dashed #D1D5DB;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.dropzone input {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
}
.dropzone label {
  color: #1F2937 !important;
}
.dropzone label u {
  text-decoration: underline;
}

.fileupload-info {
  background: #f6f8ff;
  padding: 15px;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.viewBy-filter {
  position: absolute;
  top: 0;
  left: 0;
  padding-top: 0.5rem;
}

.align-name-fields {
  display: flex;
  gap: 1rem;
}

.opacity7 {
  opacity: 0.7;
}

.button-container {
  position: sticky;
  z-index: 999;
  bottom: 0;
  background: #fff;
}

/* Bulk-upload duplicate-handling dialog (IOHB-1713) */
.duplicate-mrn-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-height: 150px;
  overflow-y: auto;
  margin-top: 4px;
}

.duplicate-mrn-chip {
  background: #eef2ff;
  color: #2d388b;
  border-radius: 12px;
  padding: 2px 10px;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
}

.duplicate-dialog-footer {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 12px;
  /* .btn-cancel is a fixed 186px globally, which overflows a dialog footer
     holding three buttons — size the buttons to their content here instead. */
}
.duplicate-dialog-footer .btn-cancel,
.duplicate-dialog-footer .p-button {
  width: auto;
  min-width: 120px;
  height: 44px;
  padding: 0 18px;
  white-space: nowrap;
}

@media (max-width: 640px) {
  .duplicate-dialog-footer .btn-cancel,
  .duplicate-dialog-footer .p-button {
    width: 100%;
  }
}
::ng-deep .upload-company-dropdown,
::ng-deep .upload-template-dropdown {
  min-width: 220px;
}

.coordination-note-upload-btn {
  width: auto !important;
  min-width: 0 !important;
  max-width: none !important;
  flex: 0 0 auto !important;
}
.coordination-note-upload-btn ::ng-deep .p-button {
  white-space: nowrap;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
